export enum ActivityStatus {
  Completed = "completed",
  Interactive = "interactive",
  Scheduled = "scheduled",
  Unsuccessful = "unsuccessful",
  Unknown = "unknown",
  DroppedOut = "dropped_out",
  AutomaticDroppedOut = "automatic_dropped_out",
}
